<template>
  <v-card v-if="(GETTERS_INPUT_ALL !== null) && (GETTERS_INPUT_ALL !== undefined)" class="main-card">
    <v-card-title text-color="#15336d">
      <v-icon left color="#15336d">mdi-label</v-icon>
      №{{GETTERS_INPUT_ALL.id}} {{GETTERS_INPUT_ALL.name}}
    </v-card-title>
    <div class="pl-10 pb-2" v-if="GETTERS_INPUT_ALL.keywords && GETTERS_INPUT_ALL.keywords.length > 0">
      <b>{{GETTERS_INPUT_ALL.keywords}}</b>
    </div>

    <div v-if="GETTERS_INPUT_ALL.last_status_id == 12" style="width: 100%; padding-left: 30px;">
      <v-chip color="#892121" text-color="white">
        <v-icon left>mdi-check-decagram</v-icon>
        Удалена
      </v-chip>
    </div>
    <div v-else-if="GETTERS_INPUT_ALL.last_status_id == 13" style="width: 100%; padding-left: 30px;">
      <v-chip color="#1c6672" text-color="white">
        <v-icon left>mdi-check-decagram</v-icon>
        Архив
      </v-chip>
    </div>
    <div v-else-if="GETTERS_INPUT_ALL.last_status_id == 6 || GETTERS_INPUT_ALL.last_status_id == 11" style="width: 100%; padding-left: 30px;">
      <v-chip color="#15336d" text-color="white">
        <v-icon left>mdi-check-decagram</v-icon>
        Черновик
      </v-chip>
      <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip color="#15336d" text-color="white">
        <v-icon left>mdi-check-decagram</v-icon>
        Подана на экспертизу
      </v-chip>
      <!-- <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip color="#15336d" text-color="white">
        <v-icon left>mdi-check-decagram</v-icon>
        На экспертизе
      </v-chip> -->
      <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip v-if="GETTERS_INPUT_ALL.last_status_id == 6" color="#f4a120" text-color="white">
        <v-icon left>mdi-decagram</v-icon>
        На доработке
      </v-chip>
      <v-chip v-else color="#e00505" text-color="white">
        <v-icon left>mdi-decagram</v-icon>
        Отклонена
      </v-chip>
    </div>

    <div v-else-if="GETTERS_INPUT_ALL.last_status_id == 14" style="width: 100%; padding-left: 30px;">
      <v-chip color=#15336d text-color="white">
        <v-icon left>mdi-check-decagram</v-icon>
        Черновик
      </v-chip>
      <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip color=#15336d text-color="white">
        <v-icon left>mdi-check-decagram</v-icon>
        Подана на экспертизу
      </v-chip>
      <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip color=#15336d text-color="white">
        <v-icon left>mdi-check-decagram</v-icon>
        Принята
      </v-chip>
      <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip color="#e00505" text-color="white">
        <v-icon left>mdi-decagram</v-icon>
        Не реализована
      </v-chip>
    </div>

    <div v-else style="width: 100%; padding-left: 30px;">
      <v-chip :color=status_color(1) text-color="white">
        <v-icon left>{{status_mdi(1)}}</v-icon>
        Черновик
      </v-chip>
      <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip :color=status_color(2) text-color="white">
        <v-icon left>{{status_mdi(2)}}</v-icon>
        Подана на экспертизу
      </v-chip>
      <!-- <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip :color=status_color(3) text-color="white">
        <v-icon left>{{status_mdi(3)}}</v-icon>
        На экспертизе
      </v-chip> -->
      <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip :color=status_color(5) text-color="white">
        <v-icon left>{{status_mdi(5)}}</v-icon>
        Принята
      </v-chip>
      <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip :color=status_color(7) text-color="white">
        <v-icon left>{{status_mdi(7)}}</v-icon>
        Назначено время
      </v-chip>
      <v-icon v-if="GETTERS_INPUT_ALL.last_status_id == 8" style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip v-if="GETTERS_INPUT_ALL.last_status_id == 8" color="#f4a120" text-color="white">
        <v-icon left>mdi-check-decagram</v-icon>
        Ожидает отчёта
      </v-chip>
      <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip :color=status_color(9) text-color="white">
        <v-icon left>{{status_mdi(9)}}</v-icon>
        Выполнена
      </v-chip>
      <v-icon style="margin-left: 8px; margin-right: 8px;">mdi-arrow-right-bold-outline</v-icon>
      <v-chip :color=status_color(10) text-color="white">
        <v-icon left>{{status_mdi(10)}}</v-icon>
        Статья
      </v-chip>
      
    </div>

    <div class="d-flex flex-nowrap justify-space-between">
      <div style="width:70%;">
        <v-card-text style="margin-bottom: 15px; margin-left: 15px;">

<!-- MAIN INFO     -->
          <v-expansion-panels
            multiple
            v-model="panel"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>
                  <v-icon>mdi-clipboard-text</v-icon>
                  {{$t('scientific-content.text')}}
                </b>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                v-if="GETTERS_INPUT_ALL.problem_formulation"
              >
                <span v-html="_updateText(GETTERS_INPUT_ALL.problem_formulation)"></span>
              </v-expansion-panel-content>
              <v-expansion-panel-content v-else>{{$t('ModalCard.no_scientific_content')}}</v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>
                  <v-icon>mdi-clipboard-text</v-icon>
                  {{$t('scientificBackground.text')}}
                </b>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                v-if="GETTERS_INPUT_ALL.background"
              ><span v-html="_updateText(GETTERS_INPUT_ALL.background)"></span></v-expansion-panel-content>
              <v-expansion-panel-content v-else>{{$t('ModalCard.scientific_groundwork_formulated')}}</v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>
                  <v-icon>mdi-clipboard-text</v-icon>
                  {{$t('ModalCard.expected_results')}}
                </b>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                v-if="GETTERS_INPUT_ALL.expected_results"
              ><span v-html="_updateText(GETTERS_INPUT_ALL.expected_results)"></span></v-expansion-panel-content>
              <v-expansion-panel-content v-else>{{$t('ModalCard.no_results_formulated')}}</v-expansion-panel-content>
            </v-expansion-panel>

<!-- samples -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>
                  <v-icon>mdi-flask</v-icon>
                  {{$t('ModalCard.samples')}}
                </b>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12">
                    <span>{{ GETTERS_INPUT_ALL.sample_description ? GETTERS_INPUT_ALL.sample_description : 'Описание образцов отсутствует' }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <div v-for="(item, i) in GETTERS_SAMPLETYPES">
                      <span>
                        <v-icon v-if="item.id == GETTERS_INPUT_ALL.sample_type_id">mdi-checkbox-marked-circle</v-icon>
                        <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
                        {{item.name}}
                        <br />
                      </span>
                    </div>
                  </v-col>
                  
                  <v-col cols="4">
                    <span>
                        Количество образцов: {{GETTERS_INPUT_ALL.sample_count ? GETTERS_INPUT_ALL.sample_count : "не указано"}}
                        <br />
                      </span>
                    <span v-if="GETTERS_INPUT_ALL.sample_avarage_size">
                      Средний размер: {{GETTERS_INPUT_ALL.sample_avarage_size}} мм
                      <br />
                    </span>
                    <span v-if="GETTERS_INPUT_ALL.sample_surface_area">
                      Площадь поверхности: {{GETTERS_INPUT_ALL.sample_surface_area}} мм<sup>2</sup>
                      <br />
                    </span>
                    <span v-if="GETTERS_INPUT_ALL.sample_volume">
                      Объем: {{GETTERS_INPUT_ALL.sample_volume}} мм<sup>3</sup>
                      <br />
                    </span>
                    <span v-if="GETTERS_INPUT_ALL.sample_mass">
                      Масса образца: {{GETTERS_INPUT_ALL.sample_mass}} мг
                      <br />
                    </span>
                  </v-col>

                  <v-col cols="4">
                    <v-row>
                      <v-switch
                        x-small
                        color="red"
                        hide-details
                        v-model="GETTERS_INPUT_ALL.is_biohazard"
                        disabled
                        :label="$t('biologicalDanger.text')"
                      ></v-switch>
                    </v-row>
                    <v-row>

                      <v-switch
                        x-small
                        color="red"
                        hide-details
                        v-model="GETTERS_INPUT_ALL.is_toxic"
                        disabled
                        :label="$t('toxicityLabel.text')"
                      ></v-switch>
                    </v-row>
                    <v-row>

                      <v-switch
                        x-small
                        color="red"
                        hide-details
                        v-model="GETTERS_INPUT_ALL.is_different_dangerous"
                        disabled
                        :label="$t('otherDanger.text')"
                      ></v-switch>
                    </v-row>

                    <v-row class="pl-10 pt-2" v-if="GETTERS_INPUT_ALL.is_different_dangerous">
                      <span>
                        <v-icon>mdi-radioactive</v-icon>
                        {{GETTERS_INPUT_ALL.other_dangers}}
                        <br />
                      </span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>
                  <v-icon>mdi-clipboard-text</v-icon>
                  {{$t('experimentPlan.text')}}
                </b>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                v-if="GETTERS_INPUT_ALL.experiment_strategy"
              ><span v-html="_updateText(GETTERS_INPUT_ALL.experiment_strategy)"></span></v-expansion-panel-content>
              <v-expansion-panel-content v-else>{{$t('ModalCard.no_experiment_plan')}}</v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>
                  <v-icon>mdi-comment-text-outline</v-icon>
                  {{$t('ModalCard.publications')}}
                </b>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                v-if="GETTERS_INPUT_ALL.team_publications"
              >{{GETTERS_INPUT_ALL.team_publications}}</v-expansion-panel-content>
              <v-expansion-panel-content v-else>{{$t('ModalCard.there_publications')}}</v-expansion-panel-content>
            </v-expansion-panel>

<!-- equipment -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>
                  <v-icon>mdi-engine-outline</v-icon>
                  {{$t('ModalCard.equipment_label')}}
                  <!-- {{$t('optionalEquipmentLabel.text')}} -->
                </b>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <b>
                    <!-- <v-icon>mdi-clipboard-text</v-icon> -->
                    оборудование станции:
                  </b>
                  <br>
                  <div v-if="GETTERS_INPUT_ALL.additional_equipment" v-for="(addit_eq, k) in GETTERS_INPUT_ALL.additional_equipment" class="ml-3">
                    <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
                    {{addit_eq.name}} <br>
                  </div>
                  <div v-else class="ml-3">
                    {{$t('ModalCard.additional_equipment_missing')}}
                  </div>

                  <hr class="mt-2">
                  <b>
                    <!-- <v-icon>mdi-clipboard-text</v-icon> -->
                    оборудование заявителя:
                  </b>
                  <br>
                  <div class="ml-3">
                    <span v-html="_updateText(GETTERS_INPUT_ALL.applicant_equipment)" v-if="GETTERS_INPUT_ALL.applicant_equipment"></span>
                      <span v-else> - </span>
                  </div>
              </v-expansion-panel-content>


              <!-- <v-expansion-panel-content v-if="GETTERS_INPUT_ALL.additional_equipment">
                <template v-for="(addit_eq, k) in GETTERS_INPUT_ALL.additional_equipment">
                  <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
                  {{addit_eq.name}} <br>
                </template>

              </v-expansion-panel-content>
              <v-expansion-panel-content v-else>{{$t('ModalCard.additional_equipment_missing')}}</v-expansion-panel-content> -->
            </v-expansion-panel>

<!-- TEAM -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                <b>
                  <v-icon>mdi-account-multiple</v-icon>
                  {{$t('ModalCard.team_and_calendar')}}
                </b>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <Schedule-user-card
                  :id="GETTERS_INPUT_ALL.id"
                  :status_id="GETTERS_INPUT_ALL.last_status_id"
                  :idProposal="GETTERS_INPUT_ALL.id"
                  :editable="editable"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

<!-- FILES           -->
          <v-row>
            <v-card width="100%" style="margin:10px;">
              <v-list subheader>
                <v-subheader>
                  <b>
                    <v-icon>mdi-attachment</v-icon>
                    {{$t('ModalCard.attached_files')}}
                  </b>
                </v-subheader>
                <v-list-item v-if="GETTERS_INPUT_ALL.files.length === 0">{{$t('ModalCard.absent')}}</v-list-item>
                <template v-else>
                  <v-list-item v-for="item in GETTERS_INPUT_ALL.files" v-if="item.is_active == true" :key="item.id">
                    <v-list-item-avatar @click="openFile(item.name)">
                      <v-icon left>mdi-file</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-if="item.type == 1 || item.type == 2" @click="openFile(item.name)">
                        <v-badge color="red lighten-2" :content="item.type==1 ? 'Отчет' : 'Публикация'" x-small inline>
                          <p style="margin-bottom: 0px;">{{ item.name.length === 0 ? $t('untitled') : item.name.split('/').reverse()[0] }}</p>
                        </v-badge>
                      </v-list-item-title>
                      <v-list-item-title v-else v-text="item.name.length === 0 ? $t('untitled') : item.name.split('/').reverse()[0]" @click="openFile(item.name)">
                      </v-list-item-title>
                      <v-list-item-subtitle v-text="g.toDate(item.add_date)"/>
                    </v-list-item-content>
                    <v-list-item-action v-if="item.name.length !== 0">
                      <v-btn @click="openFile(item.name)" icon>
                        <v-icon color="grey lighten-1">mdi-download</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </v-row>


<!-- STATUS HISTORY BLOCK START  -->
          <v-card-title v-if="action_comments.length > 0">
            <v-chip color="#15336d" text-color="white" label>
              <v-icon left>mdi-plus-network</v-icon>
              Комментарии
            </v-chip>
          </v-card-title>
          <v-timeline :dense="true" x-small  v-if="action_comments.length > 0">
            <template>
              <v-timeline-item
                size="x-small"
                color="#15336d"
                v-for="item in action_comments"
                :key="item.id"
              >

                  <template>
                    <v-card>
                      <v-list subheader>
                        <div style="padding-top: 8px;">
                          <template>
                            <v-list-item>
                              <div class="d-flex flex-column align-start">
                                <div >
                                  {{item.date}}: {{item.text}}
                                </div>
                              </div>
                            </v-list-item>
                          </template>
                        </div>
                      </v-list>
                    </v-card>
                  </template>
              </v-timeline-item>
            </template>
          </v-timeline>
        </v-card-text>
      </div>

      <div style="margin-left: 10px; width:28%;" class="suggested">

<!-- MAIN INFO BLOCK START  -->
        <v-spacer style="height:6px;"></v-spacer>
        <template v-if="editable.buttons.upload_report">
          <v-spacer style="height:10px;"></v-spacer>
          <v-list-item>
            <template>
              <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                <v-btn
                  @click="upload_document_dialog = true, dialog_comment=''"
                  outlined
                  width="100%"
                  style="background-color: #f4a120;"
                >
                  <v-icon color="#15336d">mdi-file-document-plus</v-icon>
                  загрузить отчет
                </v-btn>
              </div>
            </template>
          </v-list-item>
        </template>

        <template v-if="editable.buttons.upload_publication">
          <v-spacer style="height:10px;"></v-spacer>
          <v-list-item>
            <template>
              <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                <v-btn
                  @click="upload_document_dialog = true, dialog_comment=''"
                  outlined
                  width="100%"
                >
                  <v-icon color="#15336d">mdi-file-document-plus</v-icon>
                  загрузить публикацию
                </v-btn>
              </div>
            </template>
          </v-list-item>
        </template>

        <template v-if="editable.buttons.request_invitation">
          <v-spacer style="height:10px;"></v-spacer>
          <v-list-item>
            <template>
              <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                <v-btn
                  @click="request_invitation_dialog = true, dialog_comment=''"
                  outlined
                  width="100%"
                >
                  <v-icon color="#15336d">mdi-file-document-alert</v-icon>
                  запросить приглашение
                </v-btn>
              </div>
            </template>
          </v-list-item>
        </template>

        <template v-if="editable.buttons.request_certificate">
          <v-spacer style="height:10px;"></v-spacer>
          <v-list-item>
            <template>
              <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                <v-btn
                  @click="request_invitation_dialog = true, dialog_comment=''"
                  outlined
                  width="100%"
                >
                  <v-icon color="#15336d">mdi-file-document-alert</v-icon>
                  запросить справку о участии
                </v-btn>
              </div>
            </template>
          </v-list-item>
        </template>

        <template v-if="editable.buttons.send_to_archive">
          <v-spacer style="height:10px;"></v-spacer>
          <v-list-item>
            <template>
              <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                <v-btn
                  @click="send_to_archive_dialog = true"
                  outlined
                  width="100%"
                >
                  <v-icon color="#15336d">mdi-archive</v-icon>
                  отправить в архив
                </v-btn>
              </div>
            </template>
          </v-list-item>
        </template>

        <template v-if="editable.buttons.edit_proposal">
          <v-spacer style="height:10px;"></v-spacer>
          <v-list-item>
            <template>
              <div class="d-flex flex-column align-start" style="width: 100%; margin-right: 30px;">
                <v-btn
                  @click="goToEditProposal()"
                  outlined
                  width="100%"
                >
                  <v-icon color="#15336d">mdi-pencil-plus</v-icon>
                  Продолжить редактирование
                </v-btn>
              </div>
            </template>
          </v-list-item>
        </template>

        <template v-if="editable.can_export" style="padding-right:30px; width:100%;">
            <v-list-item style="margin-right:30px; ">
              <v-btn
                style="margin-right:30px; margin-top:15px;"
                @click="$emit('openPdf', GETTERS_INPUT_ALL.id)"
                :disabled="GETTERS_INPUT_ALL.id.length === 0"
                outlined
                width="100%"
              >
                <v-icon color="#15336d">mdi-file-pdf</v-icon>
                {{$t('ModalCard.PDF_application')}}
              </v-btn>
            </v-list-item>
        </template>


        <h2 style="margin-bottom: 0px;">{{ GETTERS_INPUT_ALL.author }} </h2>
        <h4 style="margin-top: 0px;">{{ GETTERS_INPUT_ALL.organisation }} email:{{ GETTERS_INPUT_ALL.applicant.email }} </h4>

        
        <p class="subtitle-2 text-left">
          <v-badge color="red lighten-2" :content="$t('ModalCard.type')" x-small overlap>
            <v-chip :color="$mainColor" text-color="white">
              <v-avatar left>
                <v-icon color="white">mdi-beaker</v-icon>
              </v-avatar>
              <b
                v-if="GETTERS_INPUT_ALL.scientific_subjects"
                style="color:white;"
              >{{GETTERS_INPUT_ALL.scientific_subjects.name}}</b>
              <b v-else style="color:white;">{{$t('ModalCard.absent')}}</b>
            </v-chip>
          </v-badge>
        </p>
        <p class="subtitle-2 text-left">
          <v-badge color="red lighten-2" :content="$t('ModalCard.station')" x-small overlap>
            <v-chip :color="$mainColor" text-color="white">
              <v-avatar left>
                <v-icon color="white">mdi-google-circles</v-icon>
              </v-avatar>
              <b
                v-if="GETTERS_INPUT_ALL.stations.length !== 0"
                style="color:white;"
              >{{GETTERS_INPUT_ALL.stations[0].name}}</b>
              <b v-else style="color:white;">{{$t('ModalCard.not_specified')}}</b>
            </v-chip>
          </v-badge>
        </p>
        <div class="subtitle-2" v-if="
                station_responsibles.length > 0 
                && (
                    GETTERS_INPUT_ALL.last_status_id == statuses.Approve 
                  || GETTERS_INPUT_ALL.last_status_id == statuses.Scheduled 
                  || GETTERS_INPUT_ALL.last_status_id == statuses.Need_report)"
        >
          <b>Ответственные по станции:</b>
          <br />
          <div style="padding-right:30px;">
            <span
              style="font-size: 10px;"
              v-for="(item, index) in station_responsibles"
              :key="index"
            >
              <v-icon>mdi-account-hard-hat-outline</v-icon>
              {{item.last_name}} {{item.first_name}} {{item.middle_name}} e-mail:{{item.email}}
              <br />
            </span>
          </div>
        </div>

        <div class="subtitle-2">
          <b>{{$t('ModalCard.previous_applications')}}</b>
          <br />
          <div style="padding-right:30px;" v-if="GETTERS_INPUT_ALL.previous_proposals.length>0">
            <span
              style="font-size: 10px; cursor: pointer;"
              v-for="(item, index) in GETTERS_INPUT_ALL.previous_proposals"
              :key="index"
              @click="open_previous_proposal(item.id)"
            >
              <v-icon>mdi-arrow-left-bold-hexagon-outline</v-icon>
              №{{item.id}} "{{item.name}}"
              <br />
            </span>
          </div>
          <span v-else>{{$t('ModalCard.absent')}}</span>
        </div>
        <div class="subtitle-2">
          <b>Пучковое время :</b>
          <br />
          <div style="padding-right:30px;">
            <span>
              <v-icon>mdi-alarm</v-icon>
              запрошено : "{{GETTERS_INPUT_ALL.experiment_duration}}"
              <br />
            </span>
            <span v-if="
                   GETTERS_INPUT_ALL.last_status_id == statuses.Approve 
                || GETTERS_INPUT_ALL.last_status_id == statuses.Scheduled 
                || GETTERS_INPUT_ALL.last_status_id == statuses.Need_report 
                || GETTERS_INPUT_ALL.last_status_id == statuses.Done 
                || GETTERS_INPUT_ALL.last_status_id == statuses.Publication 
            ">
              <v-icon>mdi-alarm-check</v-icon>
              предоставлено : "{{GETTERS_INPUT_ALL.provided_experiment_duration ? GETTERS_INPUT_ALL.provided_experiment_duration : 'не определено'}}"
              <br />
            </span>
          </div>
        </div>

        <div class="subtitle-2" style="align-items: flex-start;">
          <b>Предпочтительные даты эксперимента :</b>
          <div class="date-interval d-flex justify-space-between">
            {{formate_dateinterval(GETTERS_INPUT_ALL.experiment_calendar)}}
          </div>
        </div>

<!-- EDIT BLOCK START  -->
        <div class="subtitle-2" style="align-items: flex-start;" v-if="GETTERS_INPUT_ALL.last_status_id > 6">
          <b>Запланирован эксперимент :</b>
          <br />
          <div style="padding-right:30px;">
            <span>
              <v-icon>mdi-arrow-left</v-icon>
                Расписание "переехало" в раздел "Команда, Расписание и Пропуска"
              <br />
            </span>
          </div>

          <!-- <b>Запланирован эксперимент :</b>
          <template v-if="proposal_calendar.length == 0">
            время еще не назначено, ожидайте
          </template>
          <template v-for="(item, i) in proposal_calendar">
              <div class="date-interval d-flex justify-space-between">
                {{formate_datetimeinterval(item)}}
              </div>
          </template> -->
        </div>
      </div>
    </div>

    <v-dialog max-width="750px" v-model="upload_document_dialog">
      <v-card>
        <v-card-title>
          {{GETTERS_INPUT_ALL.last_status_id === 8 ? $t('Proposal.report') : $t('Proposal.download_publication')}}
        </v-card-title>
        <v-card-text>
          <v-list-item-title v-if="GETTERS_INPUT_ALL.last_status_id === 8">{{$t('Proposal.rating_work')}}</v-list-item-title>
          <v-rating v-if="GETTERS_INPUT_ALL.last_status_id === 8" v-model="rating"></v-rating>
          <v-list-item-title v-if="GETTERS_INPUT_ALL.last_status_id === 9">{{this.$t('Proposal.annotation')}}</v-list-item-title>
          <v-textarea 
          maxlength="180"
          counter
          outlined
          :label="GETTERS_INPUT_ALL.last_status_id === 8 ? $t('Proposal.step_6_text_paceholder') : $t('Proposal.step_7_text_paceholder')"
          v-model="dialog_comment">

          </v-textarea>
          <v-list-item-title>{{$t('file-upload.text')}}</v-list-item-title>
           <v-file-input
              v-model="file"
              label="Добавить файл"
              color="#15336d"
              :success="loadedFile"
              :loading="loadedFile"
              prepend-icon="mdi-paperclip">
            </v-file-input>
        </v-card-text>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#15336d" text @click="upload_document_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text :disabled="!checkCommentFile"
            @click="upload_document()">{{$t('save')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="750px" v-model="request_invitation_dialog">
      <v-card>
        <v-card-title>
          Запрос {{GETTERS_INPUT_ALL.last_status_id === 7 || GETTERS_INPUT_ALL.last_status_id === 5 ? 'приглашения на эксперимент' : 'справки о участии в эксперименте'}}
        </v-card-title>
        <v-card-text>
          <p>Вы отправляете запрос на получение официльного документа на бланке ККСНИ КИ</p>
          <p>Процесс оформления, подписания и подгрузки скана на портал заявок может занять продолжительное время (до 10 рабочих дней)</p>
          <p>Вы получите уведомление, как только документ будет готов и подгружен на портал</p>
          <p>Скан документа вы сможете скачать в карточке заявки, оригинал возможно получить при посещении ККСНИ КИ</p>

          <v-textarea 
          maxlength="999"
          counter
          outlined
          label="Вы можете указать нюансы, необходимые вам в оформляющемся документе. Мы постараемся их учесть."
          v-model="dialog_comment">

          </v-textarea>
        </v-card-text>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#15336d" text @click="request_invitation_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text @click="request_invitation()">Отправить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="500px" v-model="send_to_archive_dialog">
      <v-card>
        <v-card-title>
          Вы уверены что хотите отправить заявку {{ GETTERS_INPUT_ALL.id }} в архив?
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#15336d" text @click="send_to_archive_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            @click="send_to_archive()">отправить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</v-card>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {ProposalStatus} from '../../store/proposalStatus.js'
import ScheduleUserCard from "../Proposals/scheduleUserCard.vue";
import { DOMEN } from '../../../vars';

export default {
  name: "userCard",
  components: {
    ScheduleUserCard
  },
  props: {
  },
  data() {
    return {
      checkComment: false,
      commentToCard: "",
      commentBsCard: '',
      statusSlug: null,
      statement: false,
      reject: false,
      modification: false,
      filesCard: [],
      panel:[0],
      statuses: null,
      editable: {
        can_edit : false,
        can_export : false,
        buttons : {
          reject : false,
          revision : false,
          accept_application : false,
          examination : false,
          next_step : false,
        }
      },
      dialog_comment: '',
      experiment_duration: '',
      send_to_archive_dialog: false,
      upload_document_dialog: false,
      request_invitation_dialog: false,
      reasons: null,
      loadedFile: false,
      file: null,
      checkFile: false,
      file_id: null,
      new_station: null,
      rating: 5,

      proposal_calendar: [],
      station_responsibles: [],
    };
  },

  beforeMount() {
    this.statuses = ProposalStatus;
    this.load_additionals();
  },

  computed: {
    ...mapGetters([
      'GETTERS_INPUT_ALL', 
      'GETTERS_BS_LIST_BY_STATION_ID',
      'GETTERS_SAMPLETYPES',
    ]),

    checkCommentFile() {
      if ((this.dialog_comment.length !== 0) && ((this.file !== null) && (this.file.length !== 0))) return true
      else return false
    },

    action_comments(){
      var comments = []

      this.GETTERS_INPUT_ALL.status.forEach(el => {
        if(el.status >= 6 && el.comments != null && el.comments != ''){
          var comment = {
            id: el.id,
            date: this.g.toDate(el.date),
            text: el.comments 
          }
          comments.push(comment)
        }
      });
      return comments
    },
  },

  methods:  {
    ...mapActions([
      'GET_PROPOSAL_AVAILABLE_ACTIONS',
      'UPDATE_PROPOSAL_STATUS',
      'FILE_SEND',
      'GET_PROPOSAL_LIST',
      'GET_INPUT_ALL',
      'NEW_INVITATION',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    open_previous_proposal(proposal_id){
      this.UPDATE_OVERLAY(true)
      this.GET_INPUT_ALL(proposal_id)
      .then(() => {
        this.UPDATE_OVERLAY(false)
      })        
    },
    
    load_additionals(){
      this.GET_PROPOSAL_AVAILABLE_ACTIONS(this.GETTERS_INPUT_ALL.id).then(res => {
        this.editable = res
      })
      if(this.GETTERS_INPUT_ALL.last_status_id > 4){
          this.load_proposal_calendars()
      }
      if(this.GETTERS_INPUT_ALL.last_status_id == 5 || this.GETTERS_INPUT_ALL.last_status_id == 7 || this.GETTERS_INPUT_ALL.last_status_id == 8){
          this.load_station_responsibles()
      }
    },

    goToEditProposal() {
      window.location.href = `/new-proposal/${this.GETTERS_INPUT_ALL.id}`
      // this.$router.push(`/new-proposal/${GETTERS_INPUT_ALL.id}`);
    },

    formate_datetimeinterval(item){
      var date_obj_1 = new Date(item.start_date)
      var date_obj_2 = new Date(item.finish_date)
      var diff = (date_obj_2 - date_obj_1) / 3600000

      return this.formate_datetime(date_obj_1) + ' : ' + this.formate_datetime(date_obj_2) + ' (' + diff.toFixed(1) + ' ч.)'
    },

    formate_datetime(date_obj){
      var month = date_obj.getMonth() + 1
      var date = date_obj.getDate() 
      var m = date_obj.getMinutes()
      var h = date_obj.getHours()
      if (h<10) h = '0'+h
      if (m<10) m = '0'+m
      if (month<10) month = '0' + month
      if (date<10) date = '0' + date

      return date + '.' + month + '.' + date_obj.getFullYear() + ' ' + h + ':' + m
    },

    formate_dateinterval(str){
      if(str == null || str.length == 0)
        return 'Не указаны'
      
      var dates = str.split(':')
      if(dates[0] == 'undefined')
        return 'Не указаны'
  
        dates[0] = dates[0].split('-').reverse().join('.')
        dates[1] = dates[1].split('-').reverse().join('.')
      return dates[0] + ' : ' + dates[1]
    },

    openFile(fileName) {
      window.open(DOMEN + `/media/${fileName}`, '_blank')
    },

    load_proposal_calendars(){
      this.GET_PROPOSAL_LIST({proposal_id: this.GETTERS_INPUT_ALL.id})
      .then((res) => {
        this.proposal_calendar = res;
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
      });
    },

    load_station_responsibles(){
      var station_id = this.GETTERS_INPUT_ALL.stations[0].id
      this.station_responsibles = this.GETTERS_BS_LIST_BY_STATION_ID(station_id)
    },

    status_color(id) {
      if(id > this.GETTERS_INPUT_ALL.last_status_id)
        return '#bbbbbb'
      else 
        return '#15336d'
    },

    status_mdi(id) {
      if(id > this.GETTERS_INPUT_ALL.last_status_id)
        return 'mdi-decagram'
      else 
        return 'mdi-check-decagram'
    },

    // _updateText: (str) => str.replace(/\n/g, '\u003cbr\u003e'),

    _updateText(str){
      var str2 = str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/`/g, '&#x60;');
      str2 = str2.replace(/\n/g, '\u003cbr\u003e')
      return str2
    },

    validateFile(val) {
          const type = val.name.split('.').pop();
        
      if (
          type === 'doc' ||
          type === 'docx' ||
          type === 'pdf' ||
          type === 'jpg' ||
          type === 'png' ||
          type === 'pptx' ||
          type === 'ppt'
      ) {
        if (val.size <= 6291456) {
        
            this.checkFile =  true
        } else {
          this.$messageHelper(this.$t('Step2.6md'), 'error')
          this.checkFile = false
          this.file = ''
          
        }
      } else {
        this.$messageHelper(this.$t('Step2.file_format_prohibited'), 'error')
        this.checkFile = false
        this.file = ''
        
      }
    },

    request_invitation(){
      var data = {
        proposal_id: this.GETTERS_INPUT_ALL.id,
        type: this.GETTERS_INPUT_ALL.last_status_id == 7 ? 1 : 2,
        user_comment: this.dialog_comment,
      }

      this.UPDATE_OVERLAY(true)
      try {
          this.NEW_INVITATION(data)
          .then((res) => {
            this.UPDATE_OVERLAY(false)
            if(res.status){
              this.$messageHelper(`Заявка на документ отправлена`, 'success', 3000)
              this.request_invitation_dialog = false
            }
            else{
              this.$messageHelper(`${this.$t('error_occurred')}`, 'error', 3000)
            }
          })
      } catch (e) {
          this.UPDATE_OVERLAY(false)
          this.$messageHelper(`${this.$t('error_occurred')}: ${e}`, 'error', 3000)
      }
    },

    upload_document() {
      if(this.checkFile) {        
        this.loadedFile = true
        const files = new FormData();
        files.append('file', this.file);
        files.append('proposal_id', this.GETTERS_INPUT_ALL.id)
        files.append('type', this.GETTERS_INPUT_ALL.last_status_id == 8 ? 1 : 2) // report : publication

        this.FILE_SEND(files)
          .then((res) => {
            this.file = null
            this.loadedFile = false
            this.file_id = res.data.id
            this.upload_document_update_status()
          })
          .catch(() => this.loadedFile = false)
      }
    },

    upload_document_update_status() {
      let dataUpdateStatus = {
        proposal_action: this.GETTERS_INPUT_ALL.last_status_id == 8 ? 'upload_report' : 'upload_publication',
        proposal_id: this.GETTERS_INPUT_ALL.id,
        comment: this.dialog_comment,
      };
      if(this.GETTERS_INPUT_ALL.last_status_id == 8)
        dataUpdateStatus['mark'] = this.rating
      if(this.file_id > 0){
        dataUpdateStatus['file_id'] = this.file_id
      }

      this.updateStatus(dataUpdateStatus);
    },

    send_to_archive() {
      let dataUpdateStatus = {
        proposal_action: 'to_archive',
        proposal_id: this.GETTERS_INPUT_ALL.id,
      };
      this.updateStatus(dataUpdateStatus);
    },

    updateStatus(dataUpdateStatus) {
      this.UPDATE_OVERLAY(true)

      this.UPDATE_PROPOSAL_STATUS(dataUpdateStatus)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.send_to_archive_dialog = false;
            this.upload_document_dialog = false;
            this.$emit('updateParent')

            this.$messageHelper(this.$t('ModeratorTab.successful_status_change'), 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });
    },
  },

  watch:{
    'GETTERS_INPUT_ALL.id'(val){
      this.load_additionals();
    },

    file(val) {
      if (val && typeof val === 'object') {
        this.validateFile(val) 
      }
    }
  },

  filters: {
    filterEmpty(val) {
      if (val === null) return 'Отсутствует';
      else if (val === undefined) return 'Отсутствует';
      else if (val.length === 0) return 'Отсутствует';

      return val;
    },
  },
};
</script>

<style scoped>
.main-card {
  background-color: #f4f5f7 !important;
  border-radius: 2px;
}
.main-card * {
  color: #15336d;
}
</style>
